// import React, { useState, useCallback, useRef, useEffect } from "react";
// import { Modal, message } from "antd";
// import {
//   BellOutlined,
//   SearchOutlined,
//   PlusOutlined,
//   DeleteOutlined,
//   FileTextOutlined,
//   MedicineBoxOutlined,
//   CalendarOutlined,
//   ClockCircleOutlined,
// } from "@ant-design/icons";
// import dayjs from "dayjs";
// import PatientService from "../../../Services/PatientService";
// import ConsultationService from "../../../Services/ConsultationService";
// import DrugServices from "../../../Services/DrugServices";

// // ─── Brand tokens ─────────────────────────────────────────────────────────────
// const C = "#189FAA";
// const CL = "#e6f7f8";

// // ─── Default notification times ───────────────────────────────────────────────
// const DEFAULT_TIMES = {
//   morningTime:   "08:00:00",
//   afternoonTime: "13:00:00",
//   eveningTime:   "18:00:00",
//   nightTime:     "21:00:00",
// };

// // ─── Days of week ─────────────────────────────────────────────────────────────
// const ALL_DAYS = [
//   { key: "monday",    label: "Mon" },
//   { key: "tuesday",   label: "Tue" },
//   { key: "wednesday", label: "Wed" },
//   { key: "thursday",  label: "Thu" },
//   { key: "friday",    label: "Fri" },
//   { key: "saturday",  label: "Sat" },
//   { key: "sunday",    label: "Sun" },
// ];

// const ALL_DAYS_TRUE = Object.fromEntries(ALL_DAYS.map((d) => [d.key, true]));
// const ALL_DAYS_FALSE = Object.fromEntries(ALL_DAYS.map((d) => [d.key, false]));

// // ─── Dosage options ───────────────────────────────────────────────────────────
// const DOSAGE_OPTIONS = [
//   { label: "1-1-1",   value: "1-1-1",   slots: 3 },
//   { label: "1-0-1",   value: "1-0-1",   slots: 3 },
//   { label: "0-1-1",   value: "0-1-1",   slots: 3 },
//   { label: "1-0-0",   value: "1-0-0",   slots: 3 },
//   { label: "0-0-1",   value: "0-0-1",   slots: 3 },
//   { label: "1-1-1-1", value: "1-1-1-1", slots: 4 },
//   { label: "1-0-1-1", value: "1-0-1-1", slots: 4 },
//   { label: "1-1-0-1", value: "1-1-0-1", slots: 4 },
//   { label: "1-0-0-1", value: "1-0-0-1", slots: 4 },
//   { label: "0-1-1-1", value: "0-1-1-1", slots: 4 },
//   { label: "Custom",  value: "Custom",  slots: null },
// ];

// const dosageToApiFlags = (dosage = "") => {
//   const parts = dosage.replace(/\s/g, "").split("-");
//   if (parts.length === 3) {
//     return {
//       morningAppl:   parts[0] === "1" ? "Y" : "N",
//       afternoonAppl: parts[1] === "1" ? "Y" : "N",
//       eveningAppl:   "N",
//       nightAppl:     parts[2] === "1" ? "Y" : "N",
//     };
//   }
//   if (parts.length === 4) {
//     return {
//       morningAppl:   parts[0] === "1" ? "Y" : "N",
//       afternoonAppl: parts[1] === "1" ? "Y" : "N",
//       eveningAppl:   parts[2] === "1" ? "Y" : "N",
//       nightAppl:     parts[3] === "1" ? "Y" : "N",
//     };
//   }
//   return { morningAppl: "Y", afternoonAppl: "Y", eveningAppl: "Y", nightAppl: "Y" };
// };

// // Convert day booleans to "Y"/"N" strings for the API
// const daysToApiFlags = (days) =>
//   Object.fromEntries(ALL_DAYS.map((d) => [d.key, days[d.key] ? "Y" : "N"]));

// // ─── SVG Illustration ─────────────────────────────────────────────────────────
// const ReminderIllustration = () => {
//   const now        = new Date();
//   const monthName  = now.toLocaleString("default", { month: "long" }).toUpperCase();
//   const year       = now.getFullYear();
//   const today      = now.getDate();
//   const totalDays  = new Date(year, now.getMonth() + 1, 0).getDate();
//   const firstDay   = new Date(year, now.getMonth(), 1).getDay();
//   const cells      = [...Array(firstDay).fill(null), ...Array.from({ length: totalDays }, (_, i) => i + 1)];
//   const hours      = now.getHours() % 12;
//   const minutes    = now.getMinutes();
//   const hourAngle  = (hours * 30 + minutes * 0.5 - 90) * (Math.PI / 180);
//   const minuteAngle = (minutes * 6 - 90) * (Math.PI / 180);
//   const cx = 370, cy = 105, r = 55;
//   return (
//     <svg viewBox="0 0 560 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
//       <defs>
//         <linearGradient id="bgGradV4" x1="0%" y1="0%" x2="100%" y2="100%">
//           <stop offset="0%" stopColor="#0d9aaa" />
//           <stop offset="100%" stopColor="#0e7b8a" />
//         </linearGradient>
//         <linearGradient id="clockGradV4" x1="0%" y1="0%" x2="100%" y2="100%">
//           <stop offset="0%" stopColor="#2ecfb3" />
//           <stop offset="100%" stopColor="#189FAA" />
//         </linearGradient>
//       </defs>
//       <rect width="560" height="200" fill="url(#bgGradV4)" rx="0" />
//       <rect x="50" y="30" width="200" height="150" rx="10" fill="white" fillOpacity="0.15" />
//       <rect x="50" y="30" width="200" height="35"  rx="10" fill="white" fillOpacity="0.2" />
//       <text x="150" y="53" textAnchor="middle" fill="white" fontSize="13" fontWeight="700" fontFamily="sans-serif">
//         {monthName} {year}
//       </text>
//       {cells.slice(0, 35).map((day, i) => {
//         const col = i % 7, row = Math.floor(i / 7), isToday = day === today;
//         return day ? (
//           <g key={i}>
//             <rect x={60 + col * 26} y={75 + row * 18} width="20" height="15" rx="3"
//               fill={isToday ? "#2ecfb3" : "white"} fillOpacity={isToday ? 1 : 0.15} />
//             <text x={70 + col * 26} y={86 + row * 18} textAnchor="middle" fill="white"
//               fontSize="7" fontWeight={isToday ? "700" : "400"} fontFamily="sans-serif"
//               fillOpacity={isToday ? 1 : 0.85}>{day}</text>
//           </g>
//         ) : null;
//       })}
//       <circle cx={cx} cy={cy} r="70" fill="url(#clockGradV4)" />
//       <circle cx={cx} cy={cy} r="60" fill="white" fillOpacity="0.12" stroke="white" strokeOpacity="0.3" strokeWidth="1.5" />
//       <line x1={cx} y1={cy} x2={cx + 32 * Math.cos(hourAngle)}  y2={cy + 32 * Math.sin(hourAngle)}  stroke="white" strokeWidth="3.5" strokeLinecap="round" />
//       <line x1={cx} y1={cy} x2={cx + 45 * Math.cos(minuteAngle)} y2={cy + 45 * Math.sin(minuteAngle)} stroke="white" strokeWidth="3"   strokeLinecap="round" />
//       <circle cx={cx} cy={cy} r="5" fill="white" />
//       {[0,30,60,90,120,150,180,210,240,270,300,330].map((deg, i) => {
//         const rad = (deg - 90) * Math.PI / 180;
//         return <line key={deg}
//           x1={cx + r * Math.cos(rad)} y1={cy + r * Math.sin(rad)}
//           x2={cx + (i % 3 === 0 ? 46 : 50) * Math.cos(rad)}
//           y2={cy + (i % 3 === 0 ? 46 : 50) * Math.sin(rad)}
//           stroke="white" strokeWidth={i % 3 === 0 ? 2.5 : 1} strokeOpacity="0.8" />;
//       })}
//     </svg>
//   );
// };

// // ─── Date Field ───────────────────────────────────────────────────────────────
// const DateField = ({ label, name, value, onChange, min, max }) => (
//   <div className="flex flex-col gap-1.5">
//     <span className="text-xs font-semibold text-gray-600 uppercase tracking-wide">{label}</span>
//     <input
//       type="date"
//       name={name}
//       value={value}
//       min={min}
//       max={max}
//       onChange={onChange}
//       className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm text-gray-700 outline-none
//         focus:border-[#189FAA] focus:ring-2 focus:ring-[#189FAA]/20 transition-all bg-gray-50
//         hover:bg-white cursor-pointer"
//     />
//   </div>
// );

// // ─── Days Selector ────────────────────────────────────────────────────────────
// const DaysSelector = ({ days, onChange }) => {
//   const allSelected = ALL_DAYS.every((d) => days[d.key]);

//   const toggleAll = () => {
//     onChange(allSelected ? { ...ALL_DAYS_FALSE } : { ...ALL_DAYS_TRUE });
//   };

//   const toggleDay = (key) => {
//     onChange({ ...days, [key]: !days[key] });
//   };

//   return (
//     <div className="mb-4">
//       <div className="flex items-center justify-between mb-2">
//         <label className="text-sm font-semibold text-gray-800">Days</label>
//         <button
//           type="button"
//           onClick={toggleAll}
//           className={`text-xs font-medium px-2 py-0.5 rounded-full border transition-all ${
//             allSelected
//               ? "bg-[#189FAA] text-white border-[#189FAA]"
//               : "border-gray-300 text-gray-500 hover:border-[#189FAA] hover:text-[#189FAA]"
//           }`}
//         >
//           All
//         </button>
//       </div>
//       <div className="flex gap-1.5 flex-wrap">
//         {ALL_DAYS.map((d) => (
//           <button
//             key={d.key}
//             type="button"
//             onClick={() => toggleDay(d.key)}
//             className={`w-10 h-10 rounded-lg border text-xs font-semibold transition-all ${
//               days[d.key]
//                 ? "bg-[#189FAA] text-white border-[#189FAA]"
//                 : "border-gray-200 text-gray-600 hover:border-[#189FAA] hover:text-[#189FAA] bg-white"
//             }`}
//           >
//             {d.label}
//           </button>
//         ))}
//       </div>
//     </div>
//   );
// };

// // ─── Add Medicine Modal ───────────────────────────────────────────────────────
// const AddMedicineModal = ({
//   open, onClose, onAdd, existingMedicines,
//   medicineOptions, medicineLoading, onSearchChange, searchVal,
// }) => {
//   const emptyForm = {
//     drugName:        "",
//     dosage:          "1-1-1",
//     customDosage:    "",
//     afterBeforeFood: "AF",
//     instruction:     "",
//     days:            { ...ALL_DAYS_TRUE },
//   };

//   const [form, setForm]               = useState(emptyForm);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const searchRef                     = useRef(null);

//   useEffect(() => {
//     if (open) { setForm(emptyForm); onSearchChange(""); }
//   }, [open]);

//   const selectedOption = DOSAGE_OPTIONS.find((o) => o.value === form.dosage) || null;
//   const isCustom       = form.dosage === "Custom";
//   const slotCount      = selectedOption?.slots ?? null;

//   const handleAdd = () => {
//     if (!form.drugName.trim()) {
//       message.warning("Please select or enter a medicine name.");
//       return;
//     }
//     const finalDosage = isCustom ? form.customDosage.trim() : form.dosage;
//     if (!finalDosage) {
//       message.warning("Please enter a dosage.");
//       return;
//     }
//     const noDaySelected = ALL_DAYS.every((d) => !form.days[d.key]);
//     if (noDaySelected) {
//       message.warning("Please select at least one day.");
//       return;
//     }
//     if (existingMedicines.some(
//       (m) => m.drugName.trim().toLowerCase() === form.drugName.trim().toLowerCase()
//     )) {
//       message.warning("Medicine already added.");
//       return;
//     }
//     onAdd({ ...form, dosage: finalDosage, prescriptionId: "" });
//     onClose();
//   };

//   return (
//     <Modal
//       open={open}
//       onCancel={onClose}
//       centered
//       footer={[]}
//       destroyOnClose
//       title={<h3 className="text-base font-bold text-gray-900">Add New Medicine</h3>}
//     >
//       <div className="px-1" style={{ maxHeight: "80vh", overflowY: "auto" }}>

//         {/* Medicine Name */}
//         <div className="mb-4 relative">
//           <label className="block text-sm font-semibold text-gray-800 mb-1.5">Medicine Name</label>
//           <div className="relative">
//             <input
//               ref={searchRef}
//               type="text"
//               placeholder="Search medicine name"
//               value={searchVal}
//               onChange={(e) => {
//                 onSearchChange(e.target.value);
//                 setForm((p) => ({ ...p, drugName: e.target.value }));
//                 setShowDropdown(true);
//               }}
//               onFocus={() => setShowDropdown(true)}
//               className="w-full border border-gray-200 rounded-lg px-3 py-2.5 pr-9 text-sm text-gray-700
//                 outline-none focus:border-[#189FAA] focus:ring-2 focus:ring-[#189FAA]/20 bg-gray-50"
//             />
//             <SearchOutlined className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" />
//           </div>
//           {showDropdown && (searchVal.length >= 3 || medicineOptions.length > 0) && (
//             <div className="absolute left-0 right-0 top-full mt-1 bg-white border border-gray-200
//               rounded-lg shadow-lg z-50 max-h-44 overflow-y-auto">
//               {medicineLoading ? (
//                 <div className="flex items-center gap-2 px-4 py-3 text-sm text-gray-500">
//                   <svg className="animate-spin h-4 w-4 text-[#189FAA]" viewBox="0 0 24 24" fill="none">
//                     <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
//                     <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
//                   </svg>
//                   Searching…
//                 </div>
//               ) : medicineOptions.length === 0 && searchVal.length >= 3 ? (
//                 <div className="px-4 py-3 text-sm text-gray-400">No medicines found</div>
//               ) : (
//                 medicineOptions.map((med, idx) => (
//                   <button
//                     key={idx}
//                     className="w-full text-left px-4 py-2.5 text-sm text-gray-700
//                       hover:bg-[#e6f7f8] transition-colors border-b border-gray-50 last:border-0"
//                     onClick={() => {
//                       const name = med.medicineName || med.name;
//                       setForm((p) => ({ ...p, drugName: name }));
//                       onSearchChange(name);
//                       setShowDropdown(false);
//                     }}
//                   >
//                     {med.medicineName || med.name}
//                   </button>
//                 ))
//               )}
//             </div>
//           )}
//         </div>

//         {/* Dosage */}
//         <div className="mb-4">
//           <label className="block text-sm font-semibold text-gray-800 mb-1">
//             Dosage (Frequency)
//             {slotCount && (
//               <span className="ml-1 text-xs font-normal text-gray-400 normal-case">
//                 ({slotCount === 4 ? "Morning – Afternoon – Evening – Night" : "Morning – Afternoon – Night"})
//               </span>
//             )}
//           </label>
//           <div className="flex flex-wrap gap-2 mt-2">
//             {DOSAGE_OPTIONS.map((opt) => (
//               <button
//                 key={opt.value}
//                 type="button"
//                 onClick={() => setForm((p) => ({ ...p, dosage: opt.value, customDosage: "" }))}
//                 className={`px-3 py-1.5 rounded-lg border text-sm font-medium transition-all ${
//                   form.dosage === opt.value
//                     ? "bg-[#189FAA] text-white border-[#189FAA]"
//                     : "border-gray-200 text-gray-700 hover:border-[#189FAA] hover:text-[#189FAA]"
//                 }`}
//               >
//                 {opt.label}
//               </button>
//             ))}
//           </div>
//           {!isCustom && slotCount && (
//             <div className="mt-2 flex gap-2 flex-wrap">
//               {(slotCount === 4
//                 ? ["Morning", "Afternoon", "Evening", "Night"]
//                 : ["Morning", "Afternoon", "Night"]
//               ).map((slot, i) => {
//                 const active = form.dosage.split("-")[i] === "1";
//                 return (
//                   <span key={slot} className={`text-xs px-2 py-0.5 rounded-full font-medium ${
//                     active ? "bg-[#e6f7f8] text-[#189FAA]" : "bg-gray-100 text-gray-400 line-through"
//                   }`}>
//                     {slot}
//                   </span>
//                 );
//               })}
//             </div>
//           )}
//           {isCustom && (
//             <input
//               type="text"
//               placeholder="e.g. 2 sprays 3x/day"
//               value={form.customDosage}
//               onChange={(e) => setForm((p) => ({ ...p, customDosage: e.target.value }))}
//               className="mt-2 w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none
//                 focus:border-[#189FAA] focus:ring-2 focus:ring-[#189FAA]/20 bg-gray-50"
//             />
//           )}
//         </div>

//         {/* Days selector */}
//         <DaysSelector days={form.days} onChange={(days) => setForm((p) => ({ ...p, days }))} />

//         {/* When to Take */}
//         <div className="mb-4">
//           <label className="block text-sm font-semibold text-gray-800 mb-2">When to Take</label>
//           <div className="grid grid-cols-2 gap-2">
//             {[{ label: "After Food", value: "AF" }, { label: "Before Food", value: "BF" }].map((opt) => (
//               <button
//                 key={opt.value}
//                 type="button"
//                 onClick={() => setForm((p) => ({ ...p, afterBeforeFood: opt.value }))}
//                 className={`flex items-center gap-2 border rounded-lg px-3 py-2.5 text-sm font-medium
//                   transition-all ${
//                     form.afterBeforeFood === opt.value
//                       ? "border-[#189FAA] text-[#189FAA] bg-[#e6f7f8]"
//                       : "border-gray-200 text-gray-600 hover:border-gray-300"
//                   }`}
//               >
//                 <span className={`w-4 h-4 rounded-full border-2 flex items-center justify-center
//                   flex-shrink-0 ${form.afterBeforeFood === opt.value ? "border-[#189FAA]" : "border-gray-300"}`}>
//                   {form.afterBeforeFood === opt.value && <span className="w-2 h-2 rounded-full bg-[#189FAA]" />}
//                 </span>
//                 {opt.label}
//               </button>
//             ))}
//           </div>
//         </div>

//         {/* Instruction */}
//         <div className="mb-5">
//           <label className="block text-sm font-semibold text-gray-800 mb-1.5">Instruction</label>
//           <textarea
//             placeholder="e.g. Take with plenty of water"
//             value={form.instruction}
//             maxLength={200}
//             onChange={(e) => setForm((p) => ({ ...p, instruction: e.target.value }))}
//             rows={3}
//             className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm text-gray-700
//               outline-none focus:border-[#189FAA] focus:ring-2 focus:ring-[#189FAA]/20
//               bg-gray-50 resize-none"
//           />
//           <div className="text-right text-xs text-gray-400 mt-0.5">{form.instruction.length}/200</div>
//         </div>

//         {/* Actions */}
//         <div className="flex items-center justify-end gap-3">
//           <button
//             onClick={onClose}
//             className="w-28 p-1 border border-[#189FAA] text-[#189FAA] font-semibold text-sm
//               rounded-md hover:bg-[#e6f7f8] transition-colors"
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleAdd}
//             className="w-28 p-1 bg-[#189FAA] text-white font-semibold text-sm rounded-md
//               hover:bg-[#14878f] active:scale-95 transition-all"
//           >
//             Add Medicine
//           </button>
//         </div>
//       </div>
//     </Modal>
//   );
// };

// // ─── Prescriptions Modal (with checkboxes per medicine) ───────────────────────
// const PrescriptionsModal = ({ open, onClose, prescriptions, loading, onConfirm }) => {
//   // selectedMap: { [consultationId]: Set of drugNames }
//   const [selectedMap, setSelectedMap] = useState({});

//   useEffect(() => {
//     if (open) setSelectedMap({});
//   }, [open]);

//   const toggleMedicine = (consultationId, drugName) => {
//     setSelectedMap((prev) => {
//       const current = new Set(prev[consultationId] || []);
//       if (current.has(drugName)) {
//         current.delete(drugName);
//       } else {
//         current.add(drugName);
//       }
//       return { ...prev, [consultationId]: current };
//     });
//   };

//   const totalSelected = Object.values(selectedMap).reduce((sum, s) => sum + s.size, 0);

//   const handleConfirm = () => {
//     if (totalSelected === 0) {
//       message.warning("Please select at least one medicine.");
//       return;
//     }
//     // Build flat list of { rx, drug } pairs
//     const selected = [];
//     prescriptions.forEach((rx) => {
//       const set = selectedMap[rx.consultationId] || new Set();
//       (rx.drugPrescription || []).forEach((drug) => {
//         if (set.has(drug.drugName)) {
//           selected.push({ rx, drug });
//         }
//       });
//     });
//     onConfirm(selected);
//   };

//   return (
//     <Modal
//       open={open}
//       onCancel={onClose}
//       centered
//       footer={null}
//       destroyOnClose
//       title={<h3 className="text-base font-bold text-gray-900">Select Prescription Medicines</h3>}
//     >
//       <div className="overflow-y-auto" style={{ maxHeight: "55vh" }}>
//         {loading ? (
//           <div className="flex flex-col items-center justify-center h-32 gap-3">
//             <svg className="animate-spin h-8 w-8 text-[#189FAA]" viewBox="0 0 24 24" fill="none">
//               <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
//               <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
//             </svg>
//             <p className="text-sm text-gray-400">Loading prescriptions…</p>
//           </div>
//         ) : prescriptions.length === 0 ? (
//           <div className="flex flex-col items-center justify-center h-32 gap-2">
//             <FileTextOutlined style={{ fontSize: 32, color: "#d1d5db" }} />
//             <p className="text-sm text-gray-400">No prescriptions found</p>
//           </div>
//         ) : (
//           prescriptions.map((rx) => {
//             const date    = rx.consultationDate ? dayjs(rx.consultationDate).format("DD MMM YYYY") : "—";
//             const drugs   = rx.drugPrescription || [];
//             const rxSel   = selectedMap[rx.consultationId] || new Set();
//             const allRxSel = drugs.length > 0 && drugs.every((d) => rxSel.has(d.drugName));

//             const toggleAllRx = () => {
//               setSelectedMap((prev) => {
//                 const current = new Set(prev[rx.consultationId] || []);
//                 if (allRxSel) {
//                   drugs.forEach((d) => current.delete(d.drugName));
//                 } else {
//                   drugs.forEach((d) => current.add(d.drugName));
//                 }
//                 return { ...prev, [rx.consultationId]: current };
//               });
//             };

//             return (
//               <div key={rx.consultationId} className="mb-3 border border-gray-200 rounded-xl overflow-hidden">
//                 {/* Prescription header */}
//                 <div className="flex items-start justify-between px-4 py-3 bg-[#f0fbfc]">
//                   <div className="flex-1 min-w-0">
//                     <p className="text-sm font-semibold text-gray-800 truncate">
//                       {rx.userName || "Doctor"}
//                     </p>
//                     <p className="text-xs text-gray-500 mt-0.5">
//                       {date} · {rx.consultationType || "Consultation"}
//                     </p>
//                     {rx.consultationReason && (
//                       <p className="text-xs text-gray-400 truncate mt-0.5">
//                         {rx.consultationReason}
//                       </p>
//                     )}
//                     <p className="text-xs text-gray-400">ID: {rx.consultationId}</p>
//                   </div>
//                   {drugs.length > 0 && (
//                     <button
//                       type="button"
//                       onClick={toggleAllRx}
//                       className={`text-xs font-medium px-2 py-0.5 rounded-full border ml-2 flex-shrink-0 transition-all ${
//                         allRxSel
//                           ? "bg-[#189FAA] text-white border-[#189FAA]"
//                           : "border-gray-300 text-gray-500 hover:border-[#189FAA] hover:text-[#189FAA]"
//                       }`}
//                     >
//                       {allRxSel ? "Deselect all" : "Select all"}
//                     </button>
//                   )}
//                 </div>

//                 {/* Medicine checkboxes */}
//                 {drugs.length === 0 ? (
//                   <p className="text-xs text-gray-400 px-4 py-3">No medicines in this prescription</p>
//                 ) : (
//                   <div className="divide-y divide-gray-100">
//                     {drugs.map((drug, i) => {
//                       const isChecked = rxSel.has(drug.drugName);
//                       return (
//                         <label
//                           key={i}
//                           className={`flex items-center gap-3 px-4 py-2.5 cursor-pointer transition-colors ${
//                             isChecked ? "bg-[#f8fffe]" : "hover:bg-gray-50"
//                           }`}
//                         >
//                           <input
//                             type="checkbox"
//                             checked={isChecked}
//                             onChange={() => toggleMedicine(rx.consultationId, drug.drugName)}
//                             className="w-4 h-4 accent-[#189FAA] cursor-pointer flex-shrink-0"
//                           />
//                           <div className="flex-1 min-w-0">
//                             <p className="text-sm font-semibold text-gray-800 truncate">
//                               {drug.drugName}
//                             </p>
//                             <p className="text-xs text-gray-500">
//                               {drug.dosage}
//                               {drug.afterBeforeFood && ` · ${drug.afterBeforeFood === "AF" ? "After Food" : "Before Food"}`}
//                             </p>
//                           </div>
//                           {isChecked && (
//                             <span className="text-[#189FAA]">
//                               <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
//                                 <polyline points="20 6 9 17 4 12" />
//                               </svg>
//                             </span>
//                           )}
//                         </label>
//                       );
//                     })}
//                   </div>
//                 )}
//               </div>
//             );
//           })
//         )}
//       </div>

//       {/* Footer */}
//       {!loading && prescriptions.length > 0 && (
//         <div className="flex items-center justify-between mt-4 pt-3 border-t border-gray-100">
//           <span className="text-xs text-gray-500">
//             {totalSelected} medicine{totalSelected !== 1 ? "s" : ""} selected
//           </span>
//           <div className="flex gap-2">
//             <button
//               onClick={onClose}
//               className="px-4 py-1.5 border border-[#189FAA] text-[#189FAA] text-sm font-semibold
//                 rounded-lg hover:bg-[#e6f7f8] transition-colors"
//             >
//               Cancel
//             </button>
//             <button
//               onClick={handleConfirm}
//               disabled={totalSelected === 0}
//               className="px-4 py-1.5 bg-[#189FAA] text-white text-sm font-semibold rounded-lg
//                 hover:bg-[#14878f] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
//             >
//               Add Selected ({totalSelected})
//             </button>
//           </div>
//         </div>
//       )}
//     </Modal>
//   );
// };

// // ─── Medicine Row (in schedule builder) ──────────────────────────────────────
// const MedicineRow = ({ med, onRemove }) => {
//   const flags     = dosageToApiFlags(med.dosage);
//   const slotLabels = [
//     flags.morningAppl   === "Y" && "Morning",
//     flags.afternoonAppl === "Y" && "Afternoon",
//     flags.eveningAppl   === "Y" && "Evening",
//     flags.nightAppl     === "Y" && "Night",
//   ].filter(Boolean);

//   const activeDays = ALL_DAYS.filter((d) => med.days?.[d.key]).map((d) => d.label);

//   return (
//     <div className="flex items-start gap-3 border border-gray-100 rounded-xl p-3 bg-white mb-2">
//       <div className="w-8 h-8 rounded-full bg-[#e6f7f8] flex items-center justify-center flex-shrink-0 mt-0.5">
//         <MedicineBoxOutlined style={{ color: C, fontSize: 14 }} />
//       </div>
//       <div className="flex-1 min-w-0">
//         <p className="text-sm font-semibold text-gray-800 truncate">{med.drugName}</p>
//         <div className="flex flex-wrap gap-x-3 gap-y-0.5 mt-0.5">
//           {med.dosage && <span className="text-xs text-gray-500">{med.dosage}</span>}
//           {slotLabels.length > 0 && (
//             <span className="text-xs text-[#189FAA] font-medium">{slotLabels.join(" · ")}</span>
//           )}
//           {med.afterBeforeFood && (
//             <span className="text-xs text-gray-400">
//               {med.afterBeforeFood === "AF" ? "After Food" : "Before Food"}
//             </span>
//           )}
//         </div>
//         {activeDays.length > 0 && activeDays.length < 7 && (
//           <div className="flex gap-1 mt-1 flex-wrap">
//             {activeDays.map((d) => (
//               <span key={d} className="text-[10px] px-1.5 py-0.5 rounded bg-[#e6f7f8] text-[#189FAA] font-medium">
//                 {d}
//               </span>
//             ))}
//           </div>
//         )}
//         {activeDays.length === 7 && (
//           <span className="text-[10px] text-gray-400 mt-0.5 inline-block">Every day</span>
//         )}
//         {med.instruction && (
//           <p className="text-xs text-gray-400 mt-0.5 truncate">{med.instruction}</p>
//         )}
//       </div>
//       <button
//         onClick={() => onRemove(med.drugName)}
//         className="w-7 h-7 flex items-center justify-center rounded-full hover:bg-red-50 transition-colors flex-shrink-0"
//       >
//         <DeleteOutlined style={{ fontSize: 13, color: "#ef4444" }} />
//       </button>
//     </div>
//   );
// };

// // ─── Reminder List Card (used in PatientSearch list modal) ────────────────────
// // Exported so PatientSearch can use it
// export const MedicineReminderCard = ({ item }) => {
//   const slotColors = {
//     Morning:   "bg-amber-50  text-amber-600  border-amber-200",
//     Afternoon: "bg-orange-50 text-orange-500 border-orange-200",
//     Evening:   "bg-purple-50 text-purple-500 border-purple-200",
//     Night:     "bg-indigo-50 text-indigo-500 border-indigo-200",
//   };
//   const activeSlots = [
//     item.morningAppl   === "Y" && { label: "Morning",   time: item.morningTime },
//     item.afternoonAppl === "Y" && { label: "Afternoon", time: item.afternoonTime },
//     item.eveningAppl   === "Y" && { label: "Evening",   time: item.eveningTime },
//     item.nightAppl     === "Y" && { label: "Night",     time: item.nightTime },
//   ].filter(Boolean);

//   const activeDays = ALL_DAYS.filter((d) => item[d.key] === "Y").map((d) => d.label);
//   const fromDate   = item.notificationFromDate?.split(" ")[0] || item.fromDate?.split(" ")[0];
//   const toDate     = item.notificationToDate?.split(" ")[0]   || item.toDate?.split(" ")[0];

//   return (
//     <div className="border border-gray-200 rounded-xl p-3 mb-2 bg-white hover:border-[#189FAA] hover:shadow-sm transition-all">
//       <div className="flex items-start justify-between gap-2 mb-2">
//         <div className="flex items-center gap-2">
//           <div className="w-8 h-8 rounded-full bg-[#e6f7f8] flex items-center justify-center flex-shrink-0">
//             <BellOutlined style={{ color: "#189FAA", fontSize: 14 }} />
//           </div>
//           <p className="text-sm font-semibold text-gray-800 leading-tight">{item.drugName}</p>
//         </div>
//         <div className="flex flex-col items-end gap-1">
//           {item.prescriptionId ? (
//             <span className="text-[10px] px-2 py-0.5 rounded-full bg-[#e6f7f8] text-[#189FAA] font-medium border border-[#189FAA]/20 whitespace-nowrap">
//               Rx: {item.prescriptionId}
//             </span>
//           ) : (
//             <span className="text-[10px] px-2 py-0.5 rounded-full bg-gray-100 text-gray-400 font-medium whitespace-nowrap">
//               Manual
//             </span>
//           )}
//           <span className={`text-[10px] px-2 py-0.5 rounded-full font-medium ${
//             item.status === 1 || item.status === "1"
//               ? "bg-green-50 text-green-600 border border-green-200"
//               : "bg-gray-100 text-gray-400"
//           }`}>
//             {item.status === 1 || item.status === "1" ? "Active" : "Inactive"}
//           </span>
//         </div>
//       </div>

//       {activeSlots.length > 0 && (
//         <div className="flex flex-wrap gap-1.5 mb-2 pl-10">
//           {activeSlots.map(({ label, time }) => (
//             <span key={label} className={`inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full border font-medium ${slotColors[label]}`}>
//               <ClockCircleOutlined style={{ fontSize: 10 }} />
//               {label} · {time?.slice(0, 5)}
//             </span>
//           ))}
//         </div>
//       )}

//       {activeDays.length > 0 && activeDays.length < 7 && (
//         <div className="flex gap-1 mb-2 pl-10 flex-wrap">
//           {activeDays.map((d) => (
//             <span key={d} className="text-[10px] px-1.5 py-0.5 rounded bg-[#e6f7f8] text-[#189FAA] font-medium">
//               {d}
//             </span>
//           ))}
//         </div>
//       )}
//       {activeDays.length === 7 && (
//         <p className="text-[10px] text-gray-400 pl-10 mb-1">Every day</p>
//       )}

//       <div className="flex items-center gap-1 pl-10 text-xs text-gray-400">
//         <CalendarOutlined style={{ fontSize: 11 }} />
//         <span>{fromDate} → {toDate}</span>
//       </div>
//     </div>
//   );
// };

// // ─── Main Modal (Schedule builder) ───────────────────────────────────────────
// function MedicineReminderModal({ open, onClose, selectedPatient, loggedUser }) {
//   const today       = new Date().toISOString().split("T")[0];
//   const nowDateTime = dayjs().format("YYYY-MM-DD HH:mm:ss");

//   const [form, setForm]             = useState({ fromDate: today, toDate: "" });
//   const [selectedMedicines, setSelectedMedicines] = useState([]);

//   const [prescriptionsOpen,   setPrescriptionsOpen]   = useState(false);
//   const [prescriptions,       setPrescriptions]       = useState([]);
//   const [prescriptionLoading, setPrescriptionLoading] = useState(false);

//   const [addMedOpen, setAddMedOpen] = useState(false);

//   const [searchVal,       setSearchVal]       = useState("");
//   const [medicineOptions, setMedicineOptions] = useState([]);
//   const [medicineLoading, setMedicineLoading] = useState(false);
//   const debounceRef = useRef(null);
//   const mountedRef  = useRef(true);

//   const [saving, setSaving] = useState(false);

//   useEffect(() => {
//     mountedRef.current = true;
//     return () => {
//       mountedRef.current = false;
//       if (debounceRef.current) clearTimeout(debounceRef.current);
//     };
//   }, []);

//   useEffect(() => {
//     if (!open) {
//       setForm({ fromDate: today, toDate: "" });
//       setSelectedMedicines([]);
//       setPrescriptions([]);
//       setSearchVal("");
//       setMedicineOptions([]);
//     }
//   }, [open]);

//   const handleSearchChange = useCallback((val) => {
//     setSearchVal(val);
//     if (debounceRef.current) clearTimeout(debounceRef.current);
//     if (val.length < 3) { setMedicineOptions([]); return; }
//     debounceRef.current = setTimeout(async () => {
//       if (!mountedRef.current) return;
//       setMedicineLoading(true);
//       try {
//         const response = await DrugServices.fetchDrugList(val);
//         if (mountedRef.current) setMedicineOptions(response?.data?.data || []);
//       } catch (e) {
//         if (mountedRef.current) {
//           setMedicineOptions([]);
//           if (e?.response?.status !== 404) message.error("Failed to search medicines.");
//         }
//       } finally {
//         if (mountedRef.current) setMedicineLoading(false);
//       }
//     }, 350);
//   }, []);

//   const handleSelectPrescription = async () => {
//     if (!selectedPatient) { message.warning("No patient selected."); return; }
//     setPrescriptionLoading(true);
//     setPrescriptionsOpen(true);
//     try {
//       const response = await ConsultationService.getPrescriptions({
//         patientId: selectedPatient.patientId,
//         detailsYN: "Y",
//       });
//       const list   = response?.data?.data || response?.data || [];
//       const sorted = [...list].sort(
//         (a, b) => new Date(b.consultationDate || 0) - new Date(a.consultationDate || 0)
//       );
//       setPrescriptions(sorted);
//     } catch {
//       message.error("Failed to load prescriptions.");
//       setPrescriptions([]);
//     } finally {
//       setPrescriptionLoading(false);
//     }
//   };

//   // Called after user clicks "Add Selected" in the prescription modal
//   const handlePrescriptionConfirm = (selectedPairs) => {
//     const newMeds = [];
//     const dupes   = [];

//     selectedPairs.forEach(({ rx, drug }) => {
//       const alreadyExists = selectedMedicines.some(
//         (m) => m.drugName.trim().toLowerCase() === (drug.drugName || "").trim().toLowerCase()
//       );
//       if (alreadyExists) {
//         dupes.push(drug.drugName);
//       } else {
//         newMeds.push({
//           drugName:        drug.drugName    || "",
//           dosage:          drug.dosage      || "1-1-1",
//           afterBeforeFood: drug.afterBeforeFood || "AF",
//           instruction:     drug.instruction || "",
//           duration:        drug.duration    || "",
//           quantity:        drug.quantity    || "",
//           composition:     drug.composition || "",
//           prescriptionId:  rx.consultationId || "",
//           days:            { ...ALL_DAYS_TRUE }, // default all days; user can edit
//         });
//       }
//     });

//     if (dupes.length > 0) message.warning(`Already added: ${dupes.join(", ")}`);
//     if (newMeds.length > 0) {
//       setSelectedMedicines((prev) => [...prev, ...newMeds]);
//       message.success(`${newMeds.length} medicine${newMeds.length > 1 ? "s" : ""} added from prescription.`);
//     }
//     setPrescriptionsOpen(false);
//   };

//   const handleAddMedicine = (med) => {
//     setSelectedMedicines((prev) => [...prev, med]);
//     setSearchVal("");
//     setMedicineOptions([]);
//   };

//   const handleRemoveMedicine = (drugName) => {
//     setSelectedMedicines((prev) => prev.filter((m) => m.drugName !== drugName));
//   };

//   const handleSave = async () => {
//     if (!form.fromDate || !form.toDate) {
//       message.warning("Please select both From Date and To Date.");
//       return;
//     }
//     if (new Date(form.toDate) < new Date(form.fromDate)) {
//       message.warning("To Date cannot be before From Date.");
//       return;
//     }
//     if (selectedMedicines.length === 0) {
//       message.warning("Please add at least one medicine.");
//       return;
//     }

//     const userId       = loggedUser?.user?.userId || "";
//     const patientId    = selectedPatient?.patientId || "";
//     const fromDateStr  = `${form.fromDate} 00:00:00`;
//     const toDateStr    = `${form.toDate} 00:00:00`;

//     const calls = selectedMedicines.map((med) => {
//       const flags    = dosageToApiFlags(med.dosage);
//       const dayFlags = daysToApiFlags(med.days || ALL_DAYS_TRUE);

//       const payload = {
//         ...flags,
//         ...DEFAULT_TIMES,
//         ...dayFlags,

//         drugName:             med.drugName,
//         fromDate:             fromDateStr,
//         toDate:               toDateStr,
//         notificationFromDate: fromDateStr,
//         notificationToDate:   toDateStr,
//         patientId,
//         prescriptionId:       med.prescriptionId || "",

//         id:           0,
//         createdBy:    userId,
//         modifiedBy:   userId,
//         createdDate:  nowDateTime,
//         modifiedDate: nowDateTime,
//         currentDate:  nowDateTime,
//         status:       1,
//       };
//       console.log('payload ',payload);
//       // return;
//       return PatientService.saveMedicineReminder(payload);
//     });

//     setSaving(true);
//     try {
//       await Promise.all(calls);
//       message.success("Medicine schedule saved successfully!");
//       onClose();
//     } catch (err) {
//       console.error(err);
//       message.error("Failed to save schedule. Please try again.");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleCancel = () => {
//     setForm({ fromDate: today, toDate: "" });
//     setSelectedMedicines([]);
//     onClose();
//   };

//   return (
//     <>
//       <Modal
//         open={open}
//         onCancel={handleCancel}
//         footer={null}
//         width={520}
//         destroyOnClose
//         centered
//         title={
//           <div className="flex items-center gap-2 pt-1">
//             <div className="w-7 h-7 rounded-full bg-[#e6f7f8] flex items-center justify-center">
//               <BellOutlined style={{ color: C, fontSize: 14 }} />
//             </div>
//             <span className="text-sm font-bold font-sans text-[#189FAA] tracking-wide">
//               Medicine Schedule
//             </span>
//           </div>
//         }
//       >
//         {/* Illustration */}
//         <div className="rounded-xl overflow-hidden h-36 mb-4 mt-2">
//           <ReminderIllustration />
//         </div>

//         {/* Date range */}
//         <div className="grid grid-cols-2 gap-3 mb-4">
//           <DateField
//             label="From Date"
//             name="fromDate"
//             value={form.fromDate}
//             onChange={(e) => setForm((p) => ({ ...p, fromDate: e.target.value }))}
//           />
//           <DateField
//             label="To Date"
//             name="toDate"
//             value={form.toDate}
//             min={form.fromDate}
//             onChange={(e) => setForm((p) => ({ ...p, toDate: e.target.value }))}
//           />
//         </div>

//         {/* Medicines section */}
//         <div className="border border-gray-100 rounded-xl p-3 bg-gray-50/50 mb-4">
//           <div className="flex items-center justify-between mb-3">
//             <span className="text-sm font-semibold text-gray-800">
//               Medicines{" "}
//               <span className="text-[#189FAA]">({selectedMedicines.length})</span>
//             </span>
//             <div className="flex items-center gap-2">
//               <button
//                 onClick={handleSelectPrescription}
//                 className="flex items-center gap-1.5 px-3 py-1.5 border border-[#189FAA]
//                   text-[#189FAA] text-xs font-semibold rounded-lg hover:bg-[#e6f7f8] transition-colors"
//               >
//                 <FileTextOutlined style={{ fontSize: 12 }} />
//                 Select Prescription
//               </button>
//               <button
//                 onClick={() => { setSearchVal(""); setMedicineOptions([]); setAddMedOpen(true); }}
//                 className="w-8 h-8 flex items-center justify-center bg-[#189FAA] text-white
//                   rounded-full hover:bg-[#14878f] transition-colors flex-shrink-0"
//               >
//                 <PlusOutlined style={{ fontSize: 14 }} />
//               </button>
//             </div>
//           </div>

//           {selectedMedicines.length === 0 ? (
//             <div className="flex flex-col items-center justify-center py-6 text-center">
//               <MedicineBoxOutlined style={{ fontSize: 28, color: "#d1d5db" }} />
//               <p className="text-sm text-gray-400 mt-2 leading-relaxed">
//                 Select a prescription or add a medicine<br />to build the schedule.
//               </p>
//             </div>
//           ) : (
//             <div className="max-h-52 overflow-y-auto pr-0.5">
//               {selectedMedicines.map((med) => (
//                 <MedicineRow key={med.drugName} med={med} onRemove={handleRemoveMedicine} />
//               ))}
//             </div>
//           )}
//         </div>

//         {/* Footer */}
//         <div className="flex justify-end gap-3">
//           <button
//             onClick={handleCancel}
//             disabled={saving}
//             className="px-6 py-2 border border-[#189FAA] text-[#189FAA] font-semibold text-sm
//               rounded-lg hover:bg-[#e6f7f8] transition-colors disabled:opacity-50"
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleSave}
//             disabled={saving}
//             className="px-6 py-2 bg-[#189FAA] text-white font-semibold text-sm rounded-lg
//               hover:bg-[#14878f] active:scale-95 transition-all disabled:opacity-50
//               disabled:cursor-not-allowed flex items-center gap-2"
//           >
//             {saving ? (
//               <>
//                 <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24" fill="none">
//                   <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
//                   <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
//                 </svg>
//                 Saving…
//               </>
//             ) : (
//               <>
//                 <BellOutlined style={{ fontSize: 13 }} />
//                 Save Schedule
//               </>
//             )}
//           </button>
//         </div>
//       </Modal>

//       <PrescriptionsModal
//         open={prescriptionsOpen}
//         onClose={() => setPrescriptionsOpen(false)}
//         prescriptions={prescriptions}
//         loading={prescriptionLoading}
//         onConfirm={handlePrescriptionConfirm}
//       />

//       <AddMedicineModal
//         open={addMedOpen}
//         onClose={() => setAddMedOpen(false)}
//         onAdd={handleAddMedicine}
//         existingMedicines={selectedMedicines}
//         medicineOptions={medicineOptions}
//         medicineLoading={medicineLoading}
//         onSearchChange={handleSearchChange}
//         searchVal={searchVal}
//       />
//     </>
//   );
// }

// export default MedicineReminderModal;

// // ─── Helpers for the date strip ───────────────────────────────────────────────

// /**
//  * Build an array of `count` day objects centred on today.
//  * We show 3 days before today + today + 3 days ahead = 7 visible initially,
//  * but the strip is scrollable so we generate 30 days (15 past + today + 14 ahead).
//  */
// const buildDayStrip = () => {
//   const days = [];
//   const DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
//   const MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
//                        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
//   const base = new Date();
//   base.setHours(0, 0, 0, 0);

//   for (let offset = -15; offset <= 14; offset++) {
//     const d = new Date(base);
//     d.setDate(base.getDate() + offset);
//     days.push({
//       // ISO date string used as key and for API calls
//       iso:     dayjs(d).format("MM/DD/YYYY"),
//       dayName: DAY_NAMES[d.getDay()],
//       date:    d.getDate(),
//       month:   MONTH_NAMES[d.getMonth()],
//       isToday: offset === 0,
//     });
//   }
//   return days;
// };

// const TODAY_ISO = dayjs().format("MM/DD/YYYY");

// // ─── Horizontal Day Strip ─────────────────────────────────────────────────────
// const DayStrip = ({ selectedIso, onSelect }) => {
//   const days        = buildDayStrip();
//   const scrollRef   = useRef(null);
//   const selectedRef = useRef(null);

//   // On mount, scroll the selected (today) day into the centre of the strip
//   useEffect(() => {
//     if (selectedRef.current && scrollRef.current) {
//       const strip    = scrollRef.current;
//       const item     = selectedRef.current;
//       const offset   = item.offsetLeft - strip.clientWidth / 2 + item.clientWidth / 2;
//       strip.scrollLeft = offset;
//     }
//   }, []);

//   return (
//     <div className="mb-4">
//       {/* Section label + subtle month/year indicator */}
//       <div className="flex items-center justify-between mb-2 px-0.5">
//         <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
//           Select Date
//         </span>
//         <span className="text-xs text-gray-400 font-medium">
//           {dayjs(selectedIso).format("MMMM YYYY")}
//         </span>
//       </div>

//       {/* Scrollable strip */}
//       <div
//         ref={scrollRef}
//         className="flex gap-2 overflow-x-auto pb-1"
//         style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
//       >
//         <style>{`.day-strip-scroll::-webkit-scrollbar { display: none; }`}</style>

//         {days.map((d) => {
//           const isSelected = d.iso === selectedIso;
//           return (
//             <button
//               key={d.iso}
//               ref={isSelected ? selectedRef : null}
//               onClick={() => onSelect(d.iso)}
//               className={`
//                 flex-shrink-0 flex flex-col items-center justify-center
//                 w-14 rounded-xl py-2.5 border transition-all duration-150
//                 ${isSelected
//                   ? "bg-[#189FAA] border-[#189FAA] shadow-md"
//                   : d.isToday
//                     ? "bg-[#e6f7f8] border-[#189FAA]/40 hover:border-[#189FAA]"
//                     : "bg-white border-gray-200 hover:border-[#189FAA]/50 hover:bg-gray-50"
//                 }
//               `}
//             >
//               {/* Day name — Mon, Tue… */}
//               <span className={`text-[10px] font-semibold leading-none mb-1 ${
//                 isSelected ? "text-white" : d.isToday ? "text-[#189FAA]" : "text-gray-400"
//               }`}>
//                 {d.dayName}
//               </span>

//               {/* Date number */}
//               <span className={`text-base font-bold leading-none mb-0.5 ${
//                 isSelected ? "text-white" : d.isToday ? "text-[#189FAA]" : "text-gray-700"
//               }`}>
//                 {d.date}
//               </span>

//               {/* Month abbreviation */}
//               <span className={`text-[10px] font-medium leading-none ${
//                 isSelected ? "text-white/80" : "text-gray-400"
//               }`}>
//                 {d.month}
//               </span>

//               {/* Today dot indicator */}
//               {d.isToday && !isSelected && (
//                 <span className="mt-1 w-1 h-1 rounded-full bg-[#189FAA]" />
//               )}
//             </button>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// // ─── Reminder List Modal (used in PatientSearch) ──────────────────────────────
// export function MedicineReminderListModal({
//   open,
//   onClose,
//   selectedPatient,
//   onAddNew,
//   nosearchfoundImg,
// }) {
//   const [list,        setList]        = useState([]);
//   const [loading,     setLoading]     = useState(false);
//   const [selectedIso, setSelectedIso] = useState(TODAY_ISO);
//   const mountedRef = useRef(true);

//   useEffect(() => {
//     mountedRef.current = true;
//     return () => { mountedRef.current = false; };
//   }, []);

//   // Fetch reminders for a specific calendar date
//   const fetchForDate = useCallback(async (iso) => {
//     if (!selectedPatient?.patientId) return;
//     setLoading(true);
//     try {
//       const dateStr = `${iso} 00:00:00`;
//       const params  = {
//         patientId: selectedPatient.patientId,
//         fromDate:  iso,
//         toDate:    iso,
//       };

//       const response = await PatientService.getMedicineReminderList(params);
//       const raw = response?.data?.data || response?.data || [];
//       // Sort by drug name for a consistent, readable list
//       const sorted = [...raw].sort((a, b) =>
//         (a.drugName || "").localeCompare(b.drugName || "")
//       );
//       if (mountedRef.current) setList(sorted);
//     } catch {
//       message.error("Failed to load medicine reminders.");
//       if (mountedRef.current) setList([]);
//     } finally {
//       if (mountedRef.current) setLoading(false);
//     }
//   }, [selectedPatient]);

//   // When modal opens, reset to today and load
//   useEffect(() => {
//     if (open) {
//       setSelectedIso(TODAY_ISO);
//       fetchForDate(TODAY_ISO);
//     }
//   }, [open, fetchForDate]);

//   const handleDaySelect = (iso) => {
//     setSelectedIso(iso);
//     fetchForDate(iso);
//   };

//   const isToday = selectedIso === TODAY_ISO;

//   return (
//     <Modal
//       title={
//         <div className="flex items-center justify-between pr-6">
//           <div className="flex items-center gap-2">
//             <div className="w-7 h-7 rounded-full bg-[#e6f7f8] flex items-center justify-center">
//               <BellOutlined style={{ color: "#189FAA", fontSize: 14 }} />
//             </div>
//             <span className="text-sm font-bold text-[#189FAA] tracking-wide">
//               Medicine Reminders
//             </span>
//           </div>
//           <button
//             onClick={onAddNew}
//             className="flex items-center gap-1.5 px-3 py-1.5 bg-[#189FAA] text-white
//               text-xs font-semibold rounded-lg hover:bg-[#14878f] transition-colors"
//           >
//             + Add New
//           </button>
//         </div>
//       }
//       open={open}
//       onCancel={onClose}
//       footer={null}
//       width={480}
//       destroyOnClose
//       centered
//     >
//       {/* ── Horizontal day/date strip ── */}
//       <DayStrip selectedIso={selectedIso} onSelect={handleDaySelect} />

//       {/* ── Medicine count label ── */}
//       <div className="flex items-center justify-between mb-3">
//         <p className="text-sm font-semibold text-gray-700">
//           Medicines{" "}
//           <span className="text-[#189FAA]">({loading ? "…" : list.length})</span>
//         </p>
//         {!isToday && (
//           <button
//             onClick={() => handleDaySelect(TODAY_ISO)}
//             className="text-xs text-[#189FAA] font-medium hover:underline"
//           >
//             Back to today
//           </button>
//         )}
//       </div>

//       {/* ── List / states ── */}
//       {loading ? (
//         <div className="flex flex-col items-center justify-center h-32 gap-3">
//           <svg className="animate-spin h-8 w-8 text-[#189FAA]" viewBox="0 0 24 24" fill="none">
//             <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
//             <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
//           </svg>
//           <p className="text-sm text-gray-400">Loading reminders…</p>
//         </div>
//       ) : list.length === 0 ? (
//         <div className="flex flex-col items-center justify-center h-32 gap-3 text-center">
//           {nosearchfoundImg ? (
//             <img src={nosearchfoundImg} alt="no-reminders" className="w-10 h-10 opacity-60" />
//           ) : (
//             <BellOutlined style={{ fontSize: 32, color: "#d1d5db" }} />
//           )}
//           <p className="text-sm text-gray-500">
//             No reminders scheduled for{" "}
//             <span className="font-medium text-gray-700">
//               {isToday ? "today" : dayjs(selectedIso).format("D MMM")}
//             </span>.
//           </p>
//           <button
//             onClick={onAddNew}
//             className="px-5 py-2 bg-[#189FAA] text-white rounded-md text-sm font-semibold
//               hover:bg-[#14878f] transition-colors"
//           >
//             Set Reminder
//           </button>
//         </div>
//       ) : (
//         <div className="max-h-[45vh] overflow-y-auto pr-0.5">
//           {list.map((item) => (
//             <MedicineReminderCard key={item.id} item={item} />
//           ))}
//         </div>
//       )}
//     </Modal>
//   );
// }

// version-4 — full overhaul
// Changes vs v3:
//  1. Days-of-week selector added to AddMedicineModal & saved to payload
//  2. Prescription medicines use checkboxes (all unchecked by default); multi-prescription selection supported
//  3. Reminder list gets Date-range filter + drug-name search + status filter + days-of-week filter
//     → calls /patientMedicationReminder/list/filter with query params
//  4. fromDate / toDate / notificationFromDate / notificationToDate all populated in payload
//  5. General cleanup: id field, status field, validation improvements

import React, { useState, useCallback, useRef, useEffect } from "react";
import { Modal, message } from "antd";
import {
  BellOutlined,
  SearchOutlined,
  PlusOutlined,
  DeleteOutlined,
  FileTextOutlined,
  MedicineBoxOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import PatientService from "../../../Services/PatientService";
import ConsultationService from "../../../Services/ConsultationService";
import DrugServices from "../../../Services/DrugServices";

// ─── Brand tokens ─────────────────────────────────────────────────────────────
const C = "#189FAA";
const CL = "#e6f7f8";

// ─── Default notification times ───────────────────────────────────────────────
const DEFAULT_TIMES = {
  morningTime:   "08:00",
  afternoonTime: "13:00",
  eveningTime:   "18:00",
  nightTime:     "21:00",
};

// ─── Days of week ─────────────────────────────────────────────────────────────
const ALL_DAYS = [
  { key: "monday",    label: "Mon" },
  { key: "tuesday",   label: "Tue" },
  { key: "wednesday", label: "Wed" },
  { key: "thursday",  label: "Thu" },
  { key: "friday",    label: "Fri" },
  { key: "saturday",  label: "Sat" },
  { key: "sunday",    label: "Sun" },
];

const ALL_DAYS_TRUE = Object.fromEntries(ALL_DAYS.map((d) => [d.key, true]));
const ALL_DAYS_FALSE = Object.fromEntries(ALL_DAYS.map((d) => [d.key, false]));

// ─── Dosage options ───────────────────────────────────────────────────────────
const DOSAGE_OPTIONS = [
  { label: "1-1-1",   value: "1-1-1",   slots: 3 },
  { label: "1-0-1",   value: "1-0-1",   slots: 3 },
  { label: "0-1-1",   value: "0-1-1",   slots: 3 },
  { label: "1-0-0",   value: "1-0-0",   slots: 3 },
  { label: "0-0-1",   value: "0-0-1",   slots: 3 },
  { label: "1-1-1-1", value: "1-1-1-1", slots: 4 },
  { label: "1-0-1-1", value: "1-0-1-1", slots: 4 },
  { label: "1-1-0-1", value: "1-1-0-1", slots: 4 },
  { label: "1-0-0-1", value: "1-0-0-1", slots: 4 },
  { label: "0-1-1-1", value: "0-1-1-1", slots: 4 },
  { label: "Custom",  value: "Custom",  slots: null },
];

const dosageToApiFlags = (dosage = "") => {
  const parts = dosage.replace(/\s/g, "").split("-");
  if (parts.length === 3) {
    return {
      morningAppl:   parts[0] === "1" ? "Y" : "N",
      afternoonAppl: parts[1] === "1" ? "Y" : "N",
      eveningAppl:   "N",
      nightAppl:     parts[2] === "1" ? "Y" : "N",
    };
  }
  if (parts.length === 4) {
    return {
      morningAppl:   parts[0] === "1" ? "Y" : "N",
      afternoonAppl: parts[1] === "1" ? "Y" : "N",
      eveningAppl:   parts[2] === "1" ? "Y" : "N",
      nightAppl:     parts[3] === "1" ? "Y" : "N",
    };
  }
  return { morningAppl: "Y", afternoonAppl: "Y", eveningAppl: "Y", nightAppl: "Y" };
};

// Convert day booleans to "Y"/"N" strings for the API
const daysToApiFlags = (days) =>
  Object.fromEntries(ALL_DAYS.map((d) => [d.key, days[d.key] ? "Y" : "N"]));

// ─── SVG Illustration ─────────────────────────────────────────────────────────
const ReminderIllustration = () => {
  const now        = new Date();
  const monthName  = now.toLocaleString("default", { month: "long" }).toUpperCase();
  const year       = now.getFullYear();
  const today      = now.getDate();
  const totalDays  = new Date(year, now.getMonth() + 1, 0).getDate();
  const firstDay   = new Date(year, now.getMonth(), 1).getDay();
  const cells      = [...Array(firstDay).fill(null), ...Array.from({ length: totalDays }, (_, i) => i + 1)];
  const hours      = now.getHours() % 12;
  const minutes    = now.getMinutes();
  const hourAngle  = (hours * 30 + minutes * 0.5 - 90) * (Math.PI / 180);
  const minuteAngle = (minutes * 6 - 90) * (Math.PI / 180);
  const cx = 370, cy = 105, r = 55;
  return (
    <svg viewBox="0 0 560 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
      <defs>
        <linearGradient id="bgGradV4" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#0d9aaa" />
          <stop offset="100%" stopColor="#0e7b8a" />
        </linearGradient>
        <linearGradient id="clockGradV4" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#2ecfb3" />
          <stop offset="100%" stopColor="#189FAA" />
        </linearGradient>
      </defs>
      <rect width="560" height="200" fill="url(#bgGradV4)" rx="0" />
      <rect x="50" y="30" width="200" height="150" rx="10" fill="white" fillOpacity="0.15" />
      <rect x="50" y="30" width="200" height="35"  rx="10" fill="white" fillOpacity="0.2" />
      <text x="150" y="53" textAnchor="middle" fill="white" fontSize="13" fontWeight="700" fontFamily="sans-serif">
        {monthName} {year}
      </text>
      {cells.slice(0, 35).map((day, i) => {
        const col = i % 7, row = Math.floor(i / 7), isToday = day === today;
        return day ? (
          <g key={i}>
            <rect x={60 + col * 26} y={75 + row * 18} width="20" height="15" rx="3"
              fill={isToday ? "#2ecfb3" : "white"} fillOpacity={isToday ? 1 : 0.15} />
            <text x={70 + col * 26} y={86 + row * 18} textAnchor="middle" fill="white"
              fontSize="7" fontWeight={isToday ? "700" : "400"} fontFamily="sans-serif"
              fillOpacity={isToday ? 1 : 0.85}>{day}</text>
          </g>
        ) : null;
      })}
      <circle cx={cx} cy={cy} r="70" fill="url(#clockGradV4)" />
      <circle cx={cx} cy={cy} r="60" fill="white" fillOpacity="0.12" stroke="white" strokeOpacity="0.3" strokeWidth="1.5" />
      <line x1={cx} y1={cy} x2={cx + 32 * Math.cos(hourAngle)}  y2={cy + 32 * Math.sin(hourAngle)}  stroke="white" strokeWidth="3.5" strokeLinecap="round" />
      <line x1={cx} y1={cy} x2={cx + 45 * Math.cos(minuteAngle)} y2={cy + 45 * Math.sin(minuteAngle)} stroke="white" strokeWidth="3"   strokeLinecap="round" />
      <circle cx={cx} cy={cy} r="5" fill="white" />
      {[0,30,60,90,120,150,180,210,240,270,300,330].map((deg, i) => {
        const rad = (deg - 90) * Math.PI / 180;
        return <line key={deg}
          x1={cx + r * Math.cos(rad)} y1={cy + r * Math.sin(rad)}
          x2={cx + (i % 3 === 0 ? 46 : 50) * Math.cos(rad)}
          y2={cy + (i % 3 === 0 ? 46 : 50) * Math.sin(rad)}
          stroke="white" strokeWidth={i % 3 === 0 ? 2.5 : 1} strokeOpacity="0.8" />;
      })}
    </svg>
  );
};

// ─── Date Field ───────────────────────────────────────────────────────────────
const DateField = ({ label, name, value, onChange, min, max }) => (
  <div className="flex flex-col gap-1.5">
    <span className="text-xs font-semibold text-gray-600 uppercase tracking-wide">{label}</span>
    <input
      type="date"
      name={name}
      value={value}
      min={min}
      max={max}
      onChange={onChange}
      className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm text-gray-700 outline-none
        focus:border-[#189FAA] focus:ring-2 focus:ring-[#189FAA]/20 transition-all bg-gray-50
        hover:bg-white cursor-pointer"
    />
  </div>
);

// ─── Days Selector ────────────────────────────────────────────────────────────
const DaysSelector = ({ days, onChange }) => {
  const allSelected = ALL_DAYS.every((d) => days[d.key]);

  const toggleAll = () => {
    onChange(allSelected ? { ...ALL_DAYS_FALSE } : { ...ALL_DAYS_TRUE });
  };

  const toggleDay = (key) => {
    onChange({ ...days, [key]: !days[key] });
  };

  return (
    <div className="mb-4">
      <div className="flex items-center justify-between mb-2">
        <label className="text-sm font-semibold text-gray-800">Days</label>
        <button
          type="button"
          onClick={toggleAll}
          className={`text-xs font-medium px-2 py-0.5 rounded-full border transition-all ${
            allSelected
              ? "bg-[#189FAA] text-white border-[#189FAA]"
              : "border-gray-300 text-gray-500 hover:border-[#189FAA] hover:text-[#189FAA]"
          }`}
        >
          All
        </button>
      </div>
      <div className="flex gap-1.5 flex-wrap">
        {ALL_DAYS.map((d) => (
          <button
            key={d.key}
            type="button"
            onClick={() => toggleDay(d.key)}
            className={`w-10 h-10 rounded-lg border text-xs font-semibold transition-all ${
              days[d.key]
                ? "bg-[#189FAA] text-white border-[#189FAA]"
                : "border-gray-200 text-gray-600 hover:border-[#189FAA] hover:text-[#189FAA] bg-white"
            }`}
          >
            {d.label}
          </button>
        ))}
      </div>
    </div>
  );
};

// ─── Add Medicine Modal ───────────────────────────────────────────────────────
const AddMedicineModal = ({
  open, onClose, onAdd, existingMedicines,
  medicineOptions, medicineLoading, onSearchChange, searchVal,
}) => {
  const emptyForm = {
    drugName:        "",
    dosage:          "1-1-1",
    customDosage:    "",
    afterBeforeFood: "AF",
    instruction:     "",
    days:            { ...ALL_DAYS_TRUE },
  };

  const [form, setForm]               = useState(emptyForm);
  const [showDropdown, setShowDropdown] = useState(false);
  const searchRef                     = useRef(null);

  useEffect(() => {
    if (open) { setForm(emptyForm); onSearchChange(""); }
  }, [open]);

  const selectedOption = DOSAGE_OPTIONS.find((o) => o.value === form.dosage) || null;
  const isCustom       = form.dosage === "Custom";
  const slotCount      = selectedOption?.slots ?? null;

  const handleAdd = () => {
    if (!form.drugName.trim()) {
      message.warning("Please select or enter a medicine name.");
      return;
    }
    const finalDosage = isCustom ? form.customDosage.trim() : form.dosage;
    if (!finalDosage) {
      message.warning("Please enter a dosage.");
      return;
    }
    const noDaySelected = ALL_DAYS.every((d) => !form.days[d.key]);
    if (noDaySelected) {
      message.warning("Please select at least one day.");
      return;
    }
    if (existingMedicines.some(
      (m) => m.drugName.trim().toLowerCase() === form.drugName.trim().toLowerCase()
    )) {
      message.warning("Medicine already added.");
      return;
    }
    onAdd({ ...form, dosage: finalDosage, prescriptionId: "" });
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      centered
      footer={[]}
      destroyOnClose
      title={<h3 className="text-base font-bold text-gray-900">Add New Medicine</h3>}
    >
      <div className="px-1" style={{ maxHeight: "80vh", overflowY: "auto" }}>

        {/* Medicine Name */}
        <div className="mb-4 relative">
          <label className="block text-sm font-semibold text-gray-800 mb-1.5">Medicine Name</label>
          <div className="relative">
            <input
              ref={searchRef}
              type="text"
              placeholder="Search medicine name"
              value={searchVal}
              onChange={(e) => {
                onSearchChange(e.target.value);
                setForm((p) => ({ ...p, drugName: e.target.value }));
                setShowDropdown(true);
              }}
              onFocus={() => setShowDropdown(true)}
              className="w-full border border-gray-200 rounded-lg px-3 py-2.5 pr-9 text-sm text-gray-700
                outline-none focus:border-[#189FAA] focus:ring-2 focus:ring-[#189FAA]/20 bg-gray-50"
            />
            <SearchOutlined className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" />
          </div>
          {showDropdown && (searchVal.length >= 3 || medicineOptions.length > 0) && (
            <div className="absolute left-0 right-0 top-full mt-1 bg-white border border-gray-200
              rounded-lg shadow-lg z-50 max-h-44 overflow-y-auto">
              {medicineLoading ? (
                <div className="flex items-center gap-2 px-4 py-3 text-sm text-gray-500">
                  <svg className="animate-spin h-4 w-4 text-[#189FAA]" viewBox="0 0 24 24" fill="none">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
                  </svg>
                  Searching…
                </div>
              ) : medicineOptions.length === 0 && searchVal.length >= 3 ? (
                <div className="px-4 py-3 text-sm text-gray-400">No medicines found</div>
              ) : (
                medicineOptions.map((med, idx) => (
                  <button
                    key={idx}
                    className="w-full text-left px-4 py-2.5 text-sm text-gray-700
                      hover:bg-[#e6f7f8] transition-colors border-b border-gray-50 last:border-0"
                    onClick={() => {
                      const name = med.medicineName || med.name;
                      setForm((p) => ({ ...p, drugName: name }));
                      onSearchChange(name);
                      setShowDropdown(false);
                    }}
                  >
                    {med.medicineName || med.name}
                  </button>
                ))
              )}
            </div>
          )}
        </div>

        {/* Dosage */}
        <div className="mb-4">
          <label className="block text-sm font-semibold text-gray-800 mb-1">
            Dosage (Frequency)
            {slotCount && (
              <span className="ml-1 text-xs font-normal text-gray-400 normal-case">
                ({slotCount === 4 ? "Morning – Afternoon – Evening – Night" : "Morning – Afternoon – Night"})
              </span>
            )}
          </label>
          <div className="flex flex-wrap gap-2 mt-2">
            {DOSAGE_OPTIONS.map((opt) => (
              <button
                key={opt.value}
                type="button"
                onClick={() => setForm((p) => ({ ...p, dosage: opt.value, customDosage: "" }))}
                className={`px-3 py-1.5 rounded-lg border text-sm font-medium transition-all ${
                  form.dosage === opt.value
                    ? "bg-[#189FAA] text-white border-[#189FAA]"
                    : "border-gray-200 text-gray-700 hover:border-[#189FAA] hover:text-[#189FAA]"
                }`}
              >
                {opt.label}
              </button>
            ))}
          </div>
          {!isCustom && slotCount && (
            <div className="mt-2 flex gap-2 flex-wrap">
              {(slotCount === 4
                ? ["Morning", "Afternoon", "Evening", "Night"]
                : ["Morning", "Afternoon", "Night"]
              ).map((slot, i) => {
                const active = form.dosage.split("-")[i] === "1";
                return (
                  <span key={slot} className={`text-xs px-2 py-0.5 rounded-full font-medium ${
                    active ? "bg-[#e6f7f8] text-[#189FAA]" : "bg-gray-100 text-gray-400 line-through"
                  }`}>
                    {slot}
                  </span>
                );
              })}
            </div>
          )}
          {isCustom && (
            <input
              type="text"
              placeholder="e.g. 2 sprays 3x/day"
              value={form.customDosage}
              onChange={(e) => setForm((p) => ({ ...p, customDosage: e.target.value }))}
              className="mt-2 w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none
                focus:border-[#189FAA] focus:ring-2 focus:ring-[#189FAA]/20 bg-gray-50"
            />
          )}
        </div>

        {/* Days selector */}
        <DaysSelector days={form.days} onChange={(days) => setForm((p) => ({ ...p, days }))} />

        {/* When to Take */}
        <div className="mb-4">
          <label className="block text-sm font-semibold text-gray-800 mb-2">When to Take</label>
          <div className="grid grid-cols-2 gap-2">
            {[{ label: "After Food", value: "AF" }, { label: "Before Food", value: "BF" }].map((opt) => (
              <button
                key={opt.value}
                type="button"
                onClick={() => setForm((p) => ({ ...p, afterBeforeFood: opt.value }))}
                className={`flex items-center gap-2 border rounded-lg px-3 py-2.5 text-sm font-medium
                  transition-all ${
                    form.afterBeforeFood === opt.value
                      ? "border-[#189FAA] text-[#189FAA] bg-[#e6f7f8]"
                      : "border-gray-200 text-gray-600 hover:border-gray-300"
                  }`}
              >
                <span className={`w-4 h-4 rounded-full border-2 flex items-center justify-center
                  flex-shrink-0 ${form.afterBeforeFood === opt.value ? "border-[#189FAA]" : "border-gray-300"}`}>
                  {form.afterBeforeFood === opt.value && <span className="w-2 h-2 rounded-full bg-[#189FAA]" />}
                </span>
                {opt.label}
              </button>
            ))}
          </div>
        </div>

        {/* Instruction */}
        <div className="mb-5">
          <label className="block text-sm font-semibold text-gray-800 mb-1.5">Instruction</label>
          <textarea
            placeholder="e.g. Take with plenty of water"
            value={form.instruction}
            maxLength={200}
            onChange={(e) => setForm((p) => ({ ...p, instruction: e.target.value }))}
            rows={3}
            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm text-gray-700
              outline-none focus:border-[#189FAA] focus:ring-2 focus:ring-[#189FAA]/20
              bg-gray-50 resize-none"
          />
          <div className="text-right text-xs text-gray-400 mt-0.5">{form.instruction.length}/200</div>
        </div>

        {/* Actions */}
        <div className="flex items-center justify-end gap-3">
          <button
            onClick={onClose}
            className="w-28 p-1 border border-[#189FAA] text-[#189FAA] font-semibold text-sm
              rounded-md hover:bg-[#e6f7f8] transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleAdd}
            className="w-28 p-1 bg-[#189FAA] text-white font-semibold text-sm rounded-md
              hover:bg-[#14878f] active:scale-95 transition-all"
          >
            Add Medicine
          </button>
        </div>
      </div>
    </Modal>
  );
};

// ─── Prescriptions Modal (with checkboxes per medicine) ───────────────────────
const PrescriptionsModal = ({ open, onClose, prescriptions, loading, onConfirm }) => {
  // selectedMap: { [consultationId]: Set of drugNames }
  const [selectedMap, setSelectedMap] = useState({});

  useEffect(() => {
    if (open) setSelectedMap({});
  }, [open]);

  const toggleMedicine = (consultationId, drugName) => {
    setSelectedMap((prev) => {
      const current = new Set(prev[consultationId] || []);
      if (current.has(drugName)) {
        current.delete(drugName);
      } else {
        current.add(drugName);
      }
      return { ...prev, [consultationId]: current };
    });
  };

  const totalSelected = Object.values(selectedMap).reduce((sum, s) => sum + s.size, 0);

  const handleConfirm = () => {
    if (totalSelected === 0) {
      message.warning("Please select at least one medicine.");
      return;
    }
    // Build flat list of { rx, drug } pairs
    const selected = [];
    prescriptions.forEach((rx) => {
      const set = selectedMap[rx.consultationId] || new Set();
      (rx.drugPrescription || []).forEach((drug) => {
        if (set.has(drug.drugName)) {
          selected.push({ rx, drug });
        }
      });
    });
    onConfirm(selected);
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      centered
      footer={null}
      destroyOnClose
      title={<h3 className="text-base font-bold text-gray-900">Select Prescription Medicines</h3>}
    >
      <div className="overflow-y-auto" style={{ maxHeight: "55vh" }}>
        {loading ? (
          <div className="flex flex-col items-center justify-center h-32 gap-3">
            <svg className="animate-spin h-8 w-8 text-[#189FAA]" viewBox="0 0 24 24" fill="none">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
            </svg>
            <p className="text-sm text-gray-400">Loading prescriptions…</p>
          </div>
        ) : prescriptions.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-32 gap-2">
            <FileTextOutlined style={{ fontSize: 32, color: "#d1d5db" }} />
            <p className="text-sm text-gray-400">No prescriptions found</p>
          </div>
        ) : (
          prescriptions.map((rx) => {
            const date    = rx.consultationDate ? dayjs(rx.consultationDate).format("DD MMM YYYY") : "—";
            const drugs   = rx.drugPrescription || [];
            const rxSel   = selectedMap[rx.consultationId] || new Set();
            const allRxSel = drugs.length > 0 && drugs.every((d) => rxSel.has(d.drugName));

            const toggleAllRx = () => {
              setSelectedMap((prev) => {
                const current = new Set(prev[rx.consultationId] || []);
                if (allRxSel) {
                  drugs.forEach((d) => current.delete(d.drugName));
                } else {
                  drugs.forEach((d) => current.add(d.drugName));
                }
                return { ...prev, [rx.consultationId]: current };
              });
            };

            return (
              <div key={rx.consultationId} className="mb-3 border border-gray-200 rounded-xl overflow-hidden">
                {/* Prescription header */}
                <div className="flex items-start justify-between px-4 py-3 bg-[#f0fbfc]">
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-gray-800 truncate">
                      {rx.userName || "Doctor"}
                    </p>
                    <p className="text-xs text-gray-500 mt-0.5">
                      {date} · {rx.consultationType || "Consultation"}
                    </p>
                    {rx.consultationReason && (
                      <p className="text-xs text-gray-400 truncate mt-0.5">
                        {rx.consultationReason}
                      </p>
                    )}
                    <p className="text-xs text-gray-400">ID: {rx.consultationId}</p>
                  </div>
                  {drugs.length > 0 && (
                    <button
                      type="button"
                      onClick={toggleAllRx}
                      className={`text-xs font-medium px-2 py-0.5 rounded-full border ml-2 flex-shrink-0 transition-all ${
                        allRxSel
                          ? "bg-[#189FAA] text-white border-[#189FAA]"
                          : "border-gray-300 text-gray-500 hover:border-[#189FAA] hover:text-[#189FAA]"
                      }`}
                    >
                      {allRxSel ? "Deselect all" : "Select all"}
                    </button>
                  )}
                </div>

                {/* Medicine checkboxes */}
                {drugs.length === 0 ? (
                  <p className="text-xs text-gray-400 px-4 py-3">No medicines in this prescription</p>
                ) : (
                  <div className="divide-y divide-gray-100">
                    {drugs.map((drug, i) => {
                      const isChecked = rxSel.has(drug.drugName);
                      return (
                        <label
                          key={i}
                          className={`flex items-center gap-3 px-4 py-2.5 cursor-pointer transition-colors ${
                            isChecked ? "bg-[#f8fffe]" : "hover:bg-gray-50"
                          }`}
                        >
                          <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={() => toggleMedicine(rx.consultationId, drug.drugName)}
                            className="w-4 h-4 accent-[#189FAA] cursor-pointer flex-shrink-0"
                          />
                          <div className="flex-1 min-w-0">
                            <p className="text-sm font-semibold text-gray-800 truncate">
                              {drug.drugName}
                            </p>
                            <p className="text-xs text-gray-500">
                              {drug.dosage}
                              {drug.afterBeforeFood && ` · ${drug.afterBeforeFood === "AF" ? "After Food" : "Before Food"}`}
                            </p>
                          </div>
                          {isChecked && (
                            <span className="text-[#189FAA]">
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="20 6 9 17 4 12" />
                              </svg>
                            </span>
                          )}
                        </label>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>

      {/* Footer */}
      {!loading && prescriptions.length > 0 && (
        <div className="flex items-center justify-between mt-4 pt-3 border-t border-gray-100">
          <span className="text-xs text-gray-500">
            {totalSelected} medicine{totalSelected !== 1 ? "s" : ""} selected
          </span>
          <div className="flex gap-2">
            <button
              onClick={onClose}
              className="px-4 py-1.5 border border-[#189FAA] text-[#189FAA] text-sm font-semibold
                rounded-lg hover:bg-[#e6f7f8] transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleConfirm}
              disabled={totalSelected === 0}
              className="px-4 py-1.5 bg-[#189FAA] text-white text-sm font-semibold rounded-lg
                hover:bg-[#14878f] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Add Selected ({totalSelected})
            </button>
          </div>
        </div>
      )}
    </Modal>
  );
};

// ─── Medicine Row (in schedule builder) ──────────────────────────────────────
const MedicineRow = ({ med, onRemove }) => {
  const flags     = dosageToApiFlags(med.dosage);
  const slotLabels = [
    flags.morningAppl   === "Y" && "Morning",
    flags.afternoonAppl === "Y" && "Afternoon",
    flags.eveningAppl   === "Y" && "Evening",
    flags.nightAppl     === "Y" && "Night",
  ].filter(Boolean);

  const activeDays = ALL_DAYS.filter((d) => med.days?.[d.key]).map((d) => d.label);

  return (
    <div className="flex items-start gap-3 border border-gray-100 rounded-xl p-3 bg-white mb-2">
      <div className="w-8 h-8 rounded-full bg-[#e6f7f8] flex items-center justify-center flex-shrink-0 mt-0.5">
        <MedicineBoxOutlined style={{ color: C, fontSize: 14 }} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-gray-800 truncate">{med.drugName}</p>
        <div className="flex flex-wrap gap-x-3 gap-y-0.5 mt-0.5">
          {med.dosage && <span className="text-xs text-gray-500">{med.dosage}</span>}
          {slotLabels.length > 0 && (
            <span className="text-xs text-[#189FAA] font-medium">{slotLabels.join(" · ")}</span>
          )}
          {med.afterBeforeFood && (
            <span className="text-xs text-gray-400">
              {med.afterBeforeFood === "AF" ? "After Food" : "Before Food"}
            </span>
          )}
        </div>
        {activeDays.length > 0 && activeDays.length < 7 && (
          <div className="flex gap-1 mt-1 flex-wrap">
            {activeDays.map((d) => (
              <span key={d} className="text-[10px] px-1.5 py-0.5 rounded bg-[#e6f7f8] text-[#189FAA] font-medium">
                {d}
              </span>
            ))}
          </div>
        )}
        {activeDays.length === 7 && (
          <span className="text-[10px] text-gray-400 mt-0.5 inline-block">Every day</span>
        )}
        {med.instruction && (
          <p className="text-xs text-gray-400 mt-0.5 truncate">{med.instruction}</p>
        )}
      </div>
      <button
        onClick={() => onRemove(med.drugName)}
        className="w-7 h-7 flex items-center justify-center rounded-full hover:bg-red-50 transition-colors flex-shrink-0"
      >
        <DeleteOutlined style={{ fontSize: 13, color: "#ef4444" }} />
      </button>
    </div>
  );
};

// ─── Reminder List Card (used in PatientSearch list modal) ────────────────────
// Exported so PatientSearch can use it
export const MedicineReminderCard = ({ item }) => {
  const slotColors = {
    Morning:   "bg-amber-50  text-amber-600  border-amber-200",
    Afternoon: "bg-orange-50 text-orange-500 border-orange-200",
    Evening:   "bg-purple-50 text-purple-500 border-purple-200",
    Night:     "bg-indigo-50 text-indigo-500 border-indigo-200",
  };
  const activeSlots = [
    item.morningAppl   === "Y" && { label: "Morning",   time: item.morningTime },
    item.afternoonAppl === "Y" && { label: "Afternoon", time: item.afternoonTime },
    item.eveningAppl   === "Y" && { label: "Evening",   time: item.eveningTime },
    item.nightAppl     === "Y" && { label: "Night",     time: item.nightTime },
  ].filter(Boolean);

  const activeDays = ALL_DAYS.filter((d) => item[d.key] === "Y").map((d) => d.label);
  const fromDate   = item.notificationFromDate?.split(" ")[0] || item.fromDate?.split(" ")[0];
  const toDate     = item.notificationToDate?.split(" ")[0]   || item.toDate?.split(" ")[0];

  return (
    <div className="border border-gray-200 rounded-xl p-3 mb-2 bg-white hover:border-[#189FAA] hover:shadow-sm transition-all">
      <div className="flex items-start justify-between gap-2 mb-2">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-full bg-[#e6f7f8] flex items-center justify-center flex-shrink-0">
            <BellOutlined style={{ color: "#189FAA", fontSize: 14 }} />
          </div>
          <p className="text-sm font-semibold text-gray-800 leading-tight">{item.drugName}</p>
        </div>
        <div className="flex flex-col items-end gap-1">
          {item.prescriptionId ? (
            <span className="text-[10px] px-2 py-0.5 rounded-full bg-[#e6f7f8] text-[#189FAA] font-medium border border-[#189FAA]/20 whitespace-nowrap">
              Rx: {item.prescriptionId}
            </span>
          ) : (
            <span className="text-[10px] px-2 py-0.5 rounded-full bg-gray-100 text-gray-400 font-medium whitespace-nowrap">
              Manual
            </span>
          )}
          <span className={`text-[10px] px-2 py-0.5 rounded-full font-medium ${
            item.status === 1 || item.status === "1"
              ? "bg-green-50 text-green-600 border border-green-200"
              : "bg-gray-100 text-gray-400"
          }`}>
            {item.status === 1 || item.status === "1" ? "Active" : "Inactive"}
          </span>
        </div>
      </div>

      {activeSlots.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mb-2 pl-10">
          {activeSlots.map(({ label, time }) => (
            <span key={label} className={`inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full border font-medium ${slotColors[label]}`}>
              <ClockCircleOutlined style={{ fontSize: 10 }} />
              {label} · {time?.slice(0, 5)}
            </span>
          ))}
        </div>
      )}

      {activeDays.length > 0 && activeDays.length < 7 && (
        <div className="flex gap-1 mb-2 pl-10 flex-wrap">
          {activeDays.map((d) => (
            <span key={d} className="text-[10px] px-1.5 py-0.5 rounded bg-[#e6f7f8] text-[#189FAA] font-medium">
              {d}
            </span>
          ))}
        </div>
      )}
      {activeDays.length === 7 && (
        <p className="text-[10px] text-gray-400 pl-10 mb-1">Every day</p>
      )}

      <div className="flex items-center gap-1 pl-10 text-xs text-gray-400">
        <CalendarOutlined style={{ fontSize: 11 }} />
        <span>{fromDate} → {toDate}</span>
      </div>
    </div>
  );
};

// ─── Main Modal (Schedule builder) ───────────────────────────────────────────
function MedicineReminderModal({ open, onClose, selectedPatient, loggedUser }) {
  const today       = new Date().toISOString().split("T")[0];
  const nowDateTime = dayjs().format("YYYY-MM-DD HH:mm:ss");

  const [form, setForm]             = useState({ fromDate: today, toDate: "" });
  const [selectedMedicines, setSelectedMedicines] = useState([]);

  const [prescriptionsOpen,   setPrescriptionsOpen]   = useState(false);
  const [prescriptions,       setPrescriptions]       = useState([]);
  const [prescriptionLoading, setPrescriptionLoading] = useState(false);

  const [addMedOpen, setAddMedOpen] = useState(false);

  const [searchVal,       setSearchVal]       = useState("");
  const [medicineOptions, setMedicineOptions] = useState([]);
  const [medicineLoading, setMedicineLoading] = useState(false);
  const debounceRef = useRef(null);
  const mountedRef  = useRef(true);

  const [saving, setSaving] = useState(false);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, []);

  useEffect(() => {
    if (!open) {
      setForm({ fromDate: today, toDate: "" });
      setSelectedMedicines([]);
      setPrescriptions([]);
      setSearchVal("");
      setMedicineOptions([]);
    }
  }, [open]);

  const handleSearchChange = useCallback((val) => {
    setSearchVal(val);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (val.length < 3) { setMedicineOptions([]); return; }
    debounceRef.current = setTimeout(async () => {
      if (!mountedRef.current) return;
      setMedicineLoading(true);
      try {
        const response = await DrugServices.fetchDrugList(val);
        if (mountedRef.current) setMedicineOptions(response?.data?.data || []);
      } catch (e) {
        if (mountedRef.current) {
          setMedicineOptions([]);
          if (e?.response?.status !== 404) message.error("Failed to search medicines.");
        }
      } finally {
        if (mountedRef.current) setMedicineLoading(false);
      }
    }, 350);
  }, []);

  const handleSelectPrescription = async () => {
    if (!selectedPatient) { message.warning("No patient selected."); return; }
    setPrescriptionLoading(true);
    setPrescriptionsOpen(true);
    try {
      const response = await ConsultationService.getPrescriptions({
        patientId: selectedPatient.patientId,
        detailsYN: "Y",
      });
      const list   = response?.data?.data || response?.data || [];
      const sorted = [...list].sort(
        (a, b) => new Date(b.consultationDate || 0) - new Date(a.consultationDate || 0)
      );
      setPrescriptions(sorted);
    } catch {
      message.error("Failed to load prescriptions.");
      setPrescriptions([]);
    } finally {
      setPrescriptionLoading(false);
    }
  };

  // Called after user clicks "Add Selected" in the prescription modal
  const handlePrescriptionConfirm = (selectedPairs) => {
    const newMeds = [];
    const dupes   = [];

    selectedPairs.forEach(({ rx, drug }) => {
      const alreadyExists = selectedMedicines.some(
        (m) => m.drugName.trim().toLowerCase() === (drug.drugName || "").trim().toLowerCase()
      );
      if (alreadyExists) {
        dupes.push(drug.drugName);
      } else {
        newMeds.push({
          drugName:        drug.drugName    || "",
          dosage:          drug.dosage      || "1-1-1",
          afterBeforeFood: drug.afterBeforeFood || "AF",
          instruction:     drug.instruction || "",
          duration:        drug.duration    || "",
          quantity:        drug.quantity    || "",
          composition:     drug.composition || "",
          prescriptionId:  rx.consultationId || "",
          days:            { ...ALL_DAYS_TRUE }, // default all days; user can edit
        });
      }
    });

    if (dupes.length > 0) message.warning(`Already added: ${dupes.join(", ")}`);
    if (newMeds.length > 0) {
      setSelectedMedicines((prev) => [...prev, ...newMeds]);
      message.success(`${newMeds.length} medicine${newMeds.length > 1 ? "s" : ""} added from prescription.`);
    }
    setPrescriptionsOpen(false);
  };

  const handleAddMedicine = (med) => {
    setSelectedMedicines((prev) => [...prev, med]);
    setSearchVal("");
    setMedicineOptions([]);
  };

  const handleRemoveMedicine = (drugName) => {
    setSelectedMedicines((prev) => prev.filter((m) => m.drugName !== drugName));
  };

  const handleSave = async () => {
    if (!form.fromDate || !form.toDate) {
      message.warning("Please select both From Date and To Date.");
      return;
    }
    if (new Date(form.toDate) < new Date(form.fromDate)) {
      message.warning("To Date cannot be before From Date.");
      return;
    }
    if (selectedMedicines.length === 0) {
      message.warning("Please add at least one medicine.");
      return;
    }

    const userId       = loggedUser?.user?.userId || "";
    const patientId    = selectedPatient?.patientId || "";
    const fromDateStr  = `${form.fromDate} 00:00:00`;
    const toDateStr    = `${form.toDate} 00:00:00`;

    const batch = selectedMedicines.map((med) => {
      const flags    = dosageToApiFlags(med.dosage);
      const dayFlags = daysToApiFlags(med.days || ALL_DAYS_TRUE);

      return {
        ...flags,
        ...dayFlags,

        // Times: HH:MM only; null when that slot is inactive
        morningTime:   flags.morningAppl   === "Y" ? DEFAULT_TIMES.morningTime   : null,
        afternoonTime: flags.afternoonAppl === "Y" ? DEFAULT_TIMES.afternoonTime : null,
        eveningTime:   flags.eveningAppl   === "Y" ? DEFAULT_TIMES.eveningTime   : null,
        nightTime:     flags.nightAppl     === "Y" ? DEFAULT_TIMES.nightTime     : null,

        drugName:             med.drugName,
        notificationFromDate: fromDateStr,
        notificationToDate:   toDateStr,
        patientId,
        // prescriptionId = consultationId for prescription-sourced meds, null for manual
        prescriptionId: med.prescriptionId || null,

        createdBy:    userId,
        modifiedBy:   userId,
        createdDate:  nowDateTime,
        modifiedDate: nowDateTime,
        currentDate:  nowDateTime,
        status:       1,
      };
    });
  
    setSaving(true);
    try {
      await PatientService.saveMedicineReminderBatch(batch);
      message.success("Medicine schedule saved successfully!");
      onClose();
    } catch (err) {
      console.error(err);
      message.error("Failed to save schedule. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    setForm({ fromDate: today, toDate: "" });
    setSelectedMedicines([]);
    onClose();
  };

  return (
    <>
      <Modal
        open={open}
        onCancel={handleCancel}
        footer={null}
        width={520}
        destroyOnClose
        centered
        title={
          <div className="flex items-center gap-2 pt-1">
            <div className="w-7 h-7 rounded-full bg-[#e6f7f8] flex items-center justify-center">
              <BellOutlined style={{ color: C, fontSize: 14 }} />
            </div>
            <span className="text-sm font-bold font-sans text-[#189FAA] tracking-wide">
              Medicine Schedule
            </span>
          </div>
        }
      >
        {/* Illustration */}
        <div className="rounded-xl overflow-hidden h-36 mb-4 mt-2">
          <ReminderIllustration />
        </div>

        {/* Date range */}
        <div className="grid grid-cols-2 gap-3 mb-4">
          <DateField
            label="From Date"
            name="fromDate"
            value={form.fromDate}
            onChange={(e) => setForm((p) => ({ ...p, fromDate: e.target.value }))}
          />
          <DateField
            label="To Date"
            name="toDate"
            value={form.toDate}
            min={form.fromDate}
            onChange={(e) => setForm((p) => ({ ...p, toDate: e.target.value }))}
          />
        </div>

        {/* Medicines section */}
        <div className="border border-gray-100 rounded-xl p-3 bg-gray-50/50 mb-4">
          <div className="flex items-center justify-between mb-3">
            <span className="text-sm font-semibold text-gray-800">
              Medicines{" "}
              <span className="text-[#189FAA]">({selectedMedicines.length})</span>
            </span>
            <div className="flex items-center gap-2">
              <button
                onClick={handleSelectPrescription}
                className="flex items-center gap-1.5 px-3 py-1.5 border border-[#189FAA]
                  text-[#189FAA] text-xs font-semibold rounded-lg hover:bg-[#e6f7f8] transition-colors"
              >
                <FileTextOutlined style={{ fontSize: 12 }} />
                Select Prescription
              </button>
              <button
                onClick={() => { setSearchVal(""); setMedicineOptions([]); setAddMedOpen(true); }}
                className="w-8 h-8 flex items-center justify-center bg-[#189FAA] text-white
                  rounded-full hover:bg-[#14878f] transition-colors flex-shrink-0"
              >
                <PlusOutlined style={{ fontSize: 14 }} />
              </button>
            </div>
          </div>

          {selectedMedicines.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-6 text-center">
              <MedicineBoxOutlined style={{ fontSize: 28, color: "#d1d5db" }} />
              <p className="text-sm text-gray-400 mt-2 leading-relaxed">
                Select a prescription or add a medicine<br />to build the schedule.
              </p>
            </div>
          ) : (
            <div className="max-h-52 overflow-y-auto pr-0.5">
              {selectedMedicines.map((med) => (
                <MedicineRow key={med.drugName} med={med} onRemove={handleRemoveMedicine} />
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3">
          <button
            onClick={handleCancel}
            disabled={saving}
            className="px-6 py-2 border border-[#189FAA] text-[#189FAA] font-semibold text-sm
              rounded-lg hover:bg-[#e6f7f8] transition-colors disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            disabled={saving}
            className="px-6 py-2 bg-[#189FAA] text-white font-semibold text-sm rounded-lg
              hover:bg-[#14878f] active:scale-95 transition-all disabled:opacity-50
              disabled:cursor-not-allowed flex items-center gap-2"
          >
            {saving ? (
              <>
                <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24" fill="none">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
                </svg>
                Saving…
              </>
            ) : (
              <>
                <BellOutlined style={{ fontSize: 13 }} />
                Save Schedule
              </>
            )}
          </button>
        </div>
      </Modal>

      <PrescriptionsModal
        open={prescriptionsOpen}
        onClose={() => setPrescriptionsOpen(false)}
        prescriptions={prescriptions}
        loading={prescriptionLoading}
        onConfirm={handlePrescriptionConfirm}
      />

      <AddMedicineModal
        open={addMedOpen}
        onClose={() => setAddMedOpen(false)}
        onAdd={handleAddMedicine}
        existingMedicines={selectedMedicines}
        medicineOptions={medicineOptions}
        medicineLoading={medicineLoading}
        onSearchChange={handleSearchChange}
        searchVal={searchVal}
      />
    </>
  );
}

export default MedicineReminderModal;

// ─── Helpers for the date strip ───────────────────────────────────────────────

/**
 * Build an array of `count` day objects centred on today.
 * We show 3 days before today + today + 3 days ahead = 7 visible initially,
 * but the strip is scrollable so we generate 30 days (15 past + today + 14 ahead).
 */
const buildDayStrip = () => {
  const days = [];
  const DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                       "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const base = new Date();
  base.setHours(0, 0, 0, 0);

  for (let offset = -15; offset <= 14; offset++) {
    const d = new Date(base);
    d.setDate(base.getDate() + offset);
    days.push({
      // ISO date string used as key and for API calls
      iso:     dayjs(d).format("MM/DD/YYYY"),
      dayName: DAY_NAMES[d.getDay()],
      date:    d.getDate(),
      month:   MONTH_NAMES[d.getMonth()],
      isToday: offset === 0,
    });
  }
  return days;
};

const TODAY_ISO = dayjs().format("MM/DD/YYYY");

// ─── Horizontal Day Strip ─────────────────────────────────────────────────────
const DayStrip = ({ selectedIso, onSelect }) => {
  const days        = buildDayStrip();
  const scrollRef   = useRef(null);
  const selectedRef = useRef(null);

  // On mount, scroll the selected (today) day into the centre of the strip
  useEffect(() => {
    if (selectedRef.current && scrollRef.current) {
      const strip    = scrollRef.current;
      const item     = selectedRef.current;
      const offset   = item.offsetLeft - strip.clientWidth / 2 + item.clientWidth / 2;
      strip.scrollLeft = offset;
    }
  }, []);

  return (
    <div className="mb-4">
      {/* Section label + subtle month/year indicator */}
      <div className="flex items-center justify-between mb-2 px-0.5">
        <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
          Select Date
        </span>
        <span className="text-xs text-gray-400 font-medium">
          {dayjs(selectedIso).format("MMMM YYYY")}
        </span>
      </div>

      {/* Scrollable strip */}
      <div
        ref={scrollRef}
        className="flex gap-2 overflow-x-auto pb-1"
        style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
      >
        <style>{`.day-strip-scroll::-webkit-scrollbar { display: none; }`}</style>

        {days.map((d) => {
          const isSelected = d.iso === selectedIso;
          return (
            <button
              key={d.iso}
              ref={isSelected ? selectedRef : null}
              onClick={() => onSelect(d.iso)}
              className={`
                flex-shrink-0 flex flex-col items-center justify-center
                w-14 rounded-xl py-2.5 border transition-all duration-150
                ${isSelected
                  ? "bg-[#189FAA] border-[#189FAA] shadow-md"
                  : d.isToday
                    ? "bg-[#e6f7f8] border-[#189FAA]/40 hover:border-[#189FAA]"
                    : "bg-white border-gray-200 hover:border-[#189FAA]/50 hover:bg-gray-50"
                }
              `}
            >
              {/* Day name — Mon, Tue… */}
              <span className={`text-[10px] font-semibold leading-none mb-1 ${
                isSelected ? "text-white" : d.isToday ? "text-[#189FAA]" : "text-gray-400"
              }`}>
                {d.dayName}
              </span>

              {/* Date number */}
              <span className={`text-base font-bold leading-none mb-0.5 ${
                isSelected ? "text-white" : d.isToday ? "text-[#189FAA]" : "text-gray-700"
              }`}>
                {d.date}
              </span>

              {/* Month abbreviation */}
              <span className={`text-[10px] font-medium leading-none ${
                isSelected ? "text-white/80" : "text-gray-400"
              }`}>
                {d.month}
              </span>

              {/* Today dot indicator */}
              {d.isToday && !isSelected && (
                <span className="mt-1 w-1 h-1 rounded-full bg-[#189FAA]" />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

// ─── Reminder List Modal (used in PatientSearch) ──────────────────────────────
export function MedicineReminderListModal({
  open,
  onClose,
  selectedPatient,
  onAddNew,
  nosearchfoundImg,
}) {
  const [list,        setList]        = useState([]);
  const [loading,     setLoading]     = useState(false);
  const [selectedIso, setSelectedIso] = useState(TODAY_ISO);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    return () => { mountedRef.current = false; };
  }, []);

  // Fetch reminders for a specific calendar date
  const fetchForDate = useCallback(async (iso) => {
    if (!selectedPatient?.patientId) return;
    setLoading(true);
    try {
      const dateStr = `${iso} 00:00:00`;
      const params  = {
        patientId: selectedPatient.patientId,
        fromDate:  iso,
        toDate:    iso,
      };

      const response = await PatientService.getMedicineReminderList(params);
      const raw = response?.data?.data || response?.data || [];
      // Sort by drug name for a consistent, readable list
      const sorted = [...raw].sort((a, b) =>
        (a.drugName || "").localeCompare(b.drugName || "")
      );
      if (mountedRef.current) setList(sorted);
    } catch {
      message.error("Failed to load medicine reminders.");
      if (mountedRef.current) setList([]);
    } finally {
      if (mountedRef.current) setLoading(false);
    }
  }, [selectedPatient]);

  // When modal opens, reset to today and load
  useEffect(() => {
    if (open) {
      setSelectedIso(TODAY_ISO);
      fetchForDate(TODAY_ISO);
    }
  }, [open, fetchForDate]);

  const handleDaySelect = (iso) => {
    setSelectedIso(iso);
    fetchForDate(iso);
  };

  const isToday = selectedIso === TODAY_ISO;

  return (
    <Modal
      title={
        <div className="flex items-center justify-between pr-6">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-full bg-[#e6f7f8] flex items-center justify-center">
              <BellOutlined style={{ color: "#189FAA", fontSize: 14 }} />
            </div>
            <span className="text-sm font-bold text-[#189FAA] tracking-wide">
              Medicine Reminders
            </span>
          </div>
          <button
            onClick={onAddNew}
            className="flex items-center gap-1.5 px-3 py-1.5 bg-[#189FAA] text-white
              text-xs font-semibold rounded-lg hover:bg-[#14878f] transition-colors"
          >
            + Add New
          </button>
        </div>
      }
      open={open}
      onCancel={onClose}
      footer={null}
      width={480}
      destroyOnClose
      centered
    >
      {/* ── Horizontal day/date strip ── */}
      <DayStrip selectedIso={selectedIso} onSelect={handleDaySelect} />

      {/* ── Medicine count label ── */}
      <div className="flex items-center justify-between mb-3">
        <p className="text-sm font-semibold text-gray-700">
          Medicines{" "}
          <span className="text-[#189FAA]">({loading ? "…" : list.length})</span>
        </p>
        {!isToday && (
          <button
            onClick={() => handleDaySelect(TODAY_ISO)}
            className="text-xs text-[#189FAA] font-medium hover:underline"
          >
            Back to today
          </button>
        )}
      </div>

      {/* ── List / states ── */}
      {loading ? (
        <div className="flex flex-col items-center justify-center h-32 gap-3">
          <svg className="animate-spin h-8 w-8 text-[#189FAA]" viewBox="0 0 24 24" fill="none">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
          </svg>
          <p className="text-sm text-gray-400">Loading reminders…</p>
        </div>
      ) : list.length === 0 ? (
        <div className="flex flex-col items-center justify-center h-32 gap-3 text-center">
          {nosearchfoundImg ? (
            <img src={nosearchfoundImg} alt="no-reminders" className="w-10 h-10 opacity-60" />
          ) : (
            <BellOutlined style={{ fontSize: 32, color: "#d1d5db" }} />
          )}
          <p className="text-sm text-gray-500">
            No reminders scheduled for{" "}
            <span className="font-medium text-gray-700">
              {isToday ? "today" : dayjs(selectedIso).format("D MMM")}
            </span>.
          </p>
          <button
            onClick={onAddNew}
            className="px-5 py-2 bg-[#189FAA] text-white rounded-md text-sm font-semibold
              hover:bg-[#14878f] transition-colors"
          >
            Set Reminder
          </button>
        </div>
      ) : (
        <div className="max-h-[45vh] overflow-y-auto pr-0.5">
          {list.map((item) => (
            <MedicineReminderCard key={item.id} item={item} />
          ))}
        </div>
      )}
    </Modal>
  );
}